import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FourOhFourComponent } from '../components/four-oh-four/four-oh-four.component';

const FOUR_OH_FOUR_ROUTES: Routes = [
  {
    path: '**',
    component: FourOhFourComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(FOUR_OH_FOUR_ROUTES)],
  exports: [RouterModule]
})
export class FourOhFourRoutes {}
